import { render, staticRenderFns } from "./MsgWarning.vue?vue&type=template&id=b0054cd4&scoped=true&"
import script from "./MsgWarning.vue?vue&type=script&lang=js&"
export * from "./MsgWarning.vue?vue&type=script&lang=js&"
import style0 from "./MsgWarning.vue?vue&type=style&index=0&id=b0054cd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0054cd4",
  null
  
)

export default component.exports